import styled from 'styled-components'
import { Container, Row } from 'react-bootstrap'

export const OpenEventsMarketplaceWrapper = styled(Container)`
  height: 100%;
  padding-top: 2rem;
  padding-bottom: 2rem;

  display: flex;
  align-items: center;
  justify-content: center;

  @media screen and (max-width: 425px) {
    height: 100%
  }
`

export const OpenEventsMarketplaceInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
`

export const OpenEventsMarketplaceTitle = styled.h2`
  font-size: 2.5rem;
  font-weight: 700;
  color: var(--text-primary);
  margin-bottom: 1rem;
  text-align: center;

  @media screen and (max-width: 768px) {
    font-size: 2rem;
  }

  @media screen and (max-width: 425px) {
    font-size: 1.5rem;
  }
`

export const OpenEventsMarketplaceCards = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
`

export const HotsiteCardsRow = styled.div`
  display: flex;
  flex-wrap: wrap;
`

export const HotsiteCardsColumn = styled.div`
  display: flex;
  padding: 1.5rem;
  justify-content: center;
  width: 25%;
  @media screen and (max-width: 1399px) {
    width: 33.33%;
  }
  @media screen and (max-width: 992px) {
    width: 50%;
  }
  @media screen and (max-width: 768px) {
    width: 100%;
  }
`
